import { Center } from "@chakra-ui/react";
export default function BadRequestPage({ minH, title = "400 Bad request" }) {
  return (
    <Center minH={minH} fontWeight="bold" fontSize={58}>
      <h1>{title}</h1>
    </Center>
  );
}
